import { some } from 'lodash-es';

export function newShipmentGuard({ customerAccounts }) {
  return some(customerAccounts, account => account.newOrder.enabled);
}

export function newQuoteGuard({ user, customerAccounts }) {
  return (
    user?.quotesEnabled &&
    some(
      customerAccounts,
      account => !account?.partner && account.newQuote?.enabled
    )
  );
}

export function newAirRetrievalGuard({ customerAccounts }) {
  return some(customerAccounts, account => account.newAirRetrieval?.enabled);
}
